import './navbar.css'
import {Link} from 'react-router-dom';
import {  useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import axios from 'axios'
import { useSelector } from 'react-redux';
// import { appAddress } from '../../App';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCartShopping } from '@fortawesome/free-solid-svg-icons'

import { useTranslation } from 'react-i18next'
import logo from '../../assets/niad.png'
import i18n from "../../i18n"
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { appAddress } from '../../App';

// const lngs = {
//     en: { nativeName: "English", flag: "us" },
//     fa: { nativeName: "Persian", flag: "fa" },
//     ar: { nativeName: "Arabic", flag: "ar" },
//   };
  
  const setLanguageAndDirection = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  
    const rootElement = document.getElementById('root');
    if (lng === 'fa' || lng === 'ar') {
      rootElement.classList.add('rtl', 'text-right');
      rootElement.classList.remove('ltr', 'text-left');
    } else {
      rootElement.classList.add('ltr', 'text-left');
      rootElement.classList.remove('rtl', 'text-right');
    }
  };
  
  const persianSwitchButton = () => setLanguageAndDirection("fa");
  const englishSwitchButton = () => setLanguageAndDirection("en");
  const arabicSwitchButton = () => setLanguageAndDirection("ar");

function Navbar() {
    
    
    const {t} = useTranslation()
    const fontClass = i18n.language === 'fa' || i18n.language === 'ar' ? 'font-persian' : 'font-englishTitle';
    const [open, setOpen]= useState(false)
    const [isScrolled, setIsScrolled] = useState(false);
    

  const auth = useSelector(state => state.auth)
  const {  isAdmin, isLogged } = auth

  useEffect(() => {
  if (open) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
}, [open]);


   useEffect(() => {
      const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Change background when scrolled down 50px
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
  }, []);


    const handleMenu = ()=> {
        setOpen((prev) => !prev)
    }

    const handleLogout = async () => {
        try {
          await axios.get(`${appAddress}/user/logout`)
          // await axios.get('/user/logout')
          localStorage.removeItem('firstLogin')
          window.location.href = '/home'
        } catch (err) {
          window.location.href = '/'
        }
      }

      const adminDash = () => {
        return (
            <li className={`cursor-pointer m-auto nav-item grayscale-0 hover:grayscale textColor text-[16px] ${fontClass}`}>
                <Link className='m-auto text-center ' to={"/dashboard"}>{ t("adminNav1")}</Link>
            </li>
        )
      }    




  return (
    <>
        {/* <div className={`w-[100%] laptop:w-[90%] p-2 sticky top-0 flex justify-center laptop:justify-around m-auto mt-3 rounded-3xl transition-all duration-300 ${isScrolled ? "bg-white shadow-md" : "bg-transparent"}`}> */}
        <div className={`w-[100%]  laptop:w-[90%] desktop:w-[90%] desktopXL:w-[85%] border-2 border-gray-400 laptop:border-hidden  p-2 sticky flex justify-between laptop:justify-around  m-auto laptop:mt-3 rounded-3xl ${isScrolled ? "bg-white shadow-md rounded-2xl" : "bg-transparent"} `}>

            {/* logo hamburger */}
            <div className="w-[40%] laptop:w-[40%]  p-1  laptop:hidden  m-auto ">
                <a href="/" className="flex items-center justify-center cursor-pointer ">
                <img className="w-[100%] tablet:w-[40%] h-[100px]  m-1" src={logo} alt="logo" /> 
                </a>
            </div>

        <div className=' desktop:w-[100%] hidden desktopXl:w-[79%]  laptop:flex  m-auto rounded-3xl  p-2 '>

            <div className='border-b-2 border-gray-400 flex items-center justify-between desktop:w-[100%] '>
            
            {/* logo */}
            <div className="w-[70%] tablet:w-[80%] laptop:w-[30%] desktop:w-[15%] p-1 ">
                <a href="/" className="flex items-center justify-start cursor-pointer w-[40%] ">
                <img className="w-[200px] h-[100px] desktop:h-[10%] desktopXL:h-[30%] " src={logo} alt="logo" /> 
                </a>
            </div>

            {/* navlink */}
            <div className={`w-[15%] hidden laptop:w-[40%]  desktop:w-[55%] desktopXL:w-[45%] laptop:flex justify-end items-center ${fontClass}`}>
                <ul className="flex navbar-nav navbar-text justify-between d-flex w-[90%]  tablet:w-[60%] desktop:w-[70%] desktopXL:w-[85%] ">
                        <li className="cursor-pointer nav-item grayscale-0 hover:grayscale textColor  text-[18px]   ">
                            <Link className=' text-center  p-2' to={"/project"}>{ t("nav3")}</Link>
                        </li>

                        <span className="border-l-2 h-6 border-gray-400 mx-1"></span>
                        <li className="cursor-pointer nav-item grayscale-0 hover:grayscale textColor text-[18px]  ">
                            <Link className=' text-center p-2' to={"/about"}>{ t("nav2")}</Link>
                        </li>
                        <span className="border-l-2 h-6 border-gray-400 mx-1"></span>
                        <li className="cursor-pointer nav-item grayscale-0 hover:grayscale textColor  text-[18px]  ">
                            <Link className=' text-center  p-2' to={"/contact"}>{ t("nav4")}</Link>
                        </li>
                        <span className="border-l-2 h-6 border-gray-400 mx-1"></span>

                        {
                            isAdmin ? <> 
                                <li className="cursor-pointer nav-item grayscale-0 hover:grayscale textColor  mr-2 text-[18px]">{adminDash()} </li> 
                                <span className="border-l-2 h-6 border-gray-400 mx-1"></span>
                            </> : ''
                        }
                        
                        {/* dropdown language */}
                        {/* dropdown language */}
                        <li className="cursor-pointer nav-item grayscale-0 hover:grayscale textColor rounded-full bg-transparent">
  <select
    className="cursor-pointer text-center textColor text-[14px] rounded-full bg-white/30 backdrop-blur-md px-4 border border-blue-950 outline-none appearance-none transition-all ease-in-out focus:ring-1 focus:ring-blue-950"
    onChange={(e) => setLanguageAndDirection(e.target.value)}
    style={{
      WebkitAppearance: "none",
      MozAppearance: "none",
      appearance: "none",
      textAlignLast: "center", 
    }}
  >
    <option
      className="text-black font-englishTitle"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(8px)",
        textAlign: "center",
      }}
      value="en"
    >
      {t("english")}
    </option>
    <option
      className="text-black font-persianTitle"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(8px)",
        textAlign: "center",
      }}
      value="fa"
    >
      {t("persian")}
    </option>
    <option
      className="text-black font-persianTitle"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(8px)",
        textAlign: "center",
      }}
      value="ar"
    >
      {t("arabic")}
    </option>
  </select>
</li>

       
                    </ul>
                {/* </div> */}
            </div>

            </div>
            
        </div>

             {/* hamburger button */}
             <div className="m-auto  w-[40%] overflow-y-auto laptop:hidden tablet:w-2/6  flex items-center justify-center">
                <button type="button" onClick={handleMenu} className="inline-grid items-center justify-between p-2 text-2xl rounded-md text-blue-950 hover:text-blue-950 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-white">
                    <span className="sr-only">{ t("hamburgNav1")}</span>

                    {open === true ? <FaTimes /> : <FaBars />}
                    
                </button>
             </div>
        </div>

        {/*  mobile */}
        {
            open ? (
        <div className='fixed inset-0 z-50 bg-white bg-opacity-95 overflow-y-auto border p-2'>
            <div className='flex flex-col items-center justify-start min-h-screen pt-10 bgBlur'>
               
            <ul className=" flex flex-col w-[90%] tablet:w-[35%] h-[80%] justify-around items-center " > 
              <button type="button" onClick={handleMenu} className="mb-7 inline-grid items-center justify-between p-2 text-2xl rounded-md text-blue-950 hover:text-blue-950 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-white">
                    <span className="sr-only">{ t("hamburgNav1")}</span>

                    {open === true ? <FaTimes /> : <FaBars />}
                    
                </button>
                <ul className="flex navbar-nav mt-7 mb-9 navbar-text d-flex w-[100%] border-b-2 p-2">
                    <li className='m-auto bg-gray-100 w-[50%] text-center ml-2 mr-2 p-2 rounded-2xl cursor-pointer nav-item grayscale-0 hover:grayscale font-persian' onClick={persianSwitchButton}>{ t("persian")}</li>
                    <li className='m-auto bg-gray-100 w-[50%] text-center ml-2 mr-2 p-2 rounded-2xl cursor-pointer nav-item grayscale-0 hover:grayscale font-englishTitle' onClick={englishSwitchButton}>{ t("english")}</li>
                    <li className='m-auto bg-gray-100 w-[50%] text-center ml-2 mr-2 p-2 rounded-2xl cursor-pointer nav-item grayscale-0 hover:grayscale font-persian' onClick={arabicSwitchButton}>{ t("arabic")}</li>
                </ul>
                
                <ul className={`flex flex-col items-center justify-start w-[100%] h-[60%] ${fontClass} `}>
                          <li className="btnColorMob text-[18px] w-[60%] textColor text-center flex justify-between tablet:w-5/6 laptop:w-6/6 desktop:w-[80px] desktopXL:w-[60px] ">
                            <Link className='m-auto text-center w-[100%]' to={"/project"}>{ t("nav3")}</Link>
                        </li>
                        <li className="btnColorMob text-[18px] w-[60%] textColor ml--2 desktopXL:ml-5 text-center flex justify-between tablet:w-5/6 laptop:w-6/6 desktop:w-[80px] desktopXL:w-[60px] ">
                            <Link className='m-auto text-center w-[100%]' to={"/about"}>{ t("nav2")}</Link>
                        </li>
                        <li className="btnColorMob  text-[18px] w-[60%] textColor ml-2  desktopXL:ml-5 text-center flex justify-between tablet:w-5/6 laptop:w-6/6 desktop:w-[80px] desktopXL:w-[90px] ">
                            <Link className='m-auto text-center w-[100%] ' to={"/contact"}>{ t("nav4")}</Link>
                        </li>

                        {
                            isAdmin ? <li className="btnColorMob  text-[18px] w-[60%] textColor ml-2 desktopXL:ml-5 text-center flex justify-between tablet:w-5/6 laptop:w-6/6 desktop:w-[80px] desktopXL:w-[60px] ">{adminDash()}</li> : ''
                        }
                        {
                            isLogged ? <li className=" btnColorMob  text-[18px] w-[60%] textColor ml-2 desktopXL:ml-9 text-center flex justify-between tablet:w-5/6 laptop:w-6/6 desktop:w-[80px] desktopXL:w-[60px] ">
                                    <Link className='m-auto text-center w-[100%]' onClick={handleLogout}>{ t("nav6")}</Link>
                                </li> : ''
                            
                        }
                        </ul>
                    </ul>
            </div>
        </div>
            ) : null
        }
    </>
  )
}

export default Navbar
